import background from './Images/cs_background.jpg'
import poster from './Images/cs_landing.jpg'

var info = {
  title: 'CounterSketch | Request Demo',
  video: 'https://gemvision.com/sharedMedia/cs_landing_video_with_music.mp4',
  poster: poster,
  background: background,
  logo: 'https://gemvision.com/Images/CounterSketch/CounterSketch-Primary-Logo-2-Color.svg',
  moto: 'All-in-One Custom Design Solution for Jewelry Businesses',
  description1:
    'Register to watch on-demand software demonstration videos and speak with a Gemvision representative about how CounterSketch can enhance your customers’ shopping experience and grow your custom business.',
  description2: 'No commitment is required.',
  buttonColor: '#3f6cb4',
  titleBackgroundColor: '#575757'
}

export default info
